import { render, staticRenderFns } from "./ReferralRecords.vue?vue&type=template&id=213c8596&scoped=true"
import script from "./ReferralRecords.vue?vue&type=script&lang=js"
export * from "./ReferralRecords.vue?vue&type=script&lang=js"
import style0 from "./ReferralRecords.vue?vue&type=style&index=0&id=213c8596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c8596",
  null
  
)

export default component.exports